import { _ as e } from "./main42.js";
var r = e, o = typeof self == "object" && self && self.Object === Object && self, t = r || o || Function("return this")(), l = t;
export {
  l as _
};
